import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@/lib/queryKeys'
import { listCalendarEvents } from '@/api/calendars'
import type { CalendarEventSummary } from '@/types'

export function useCalendarEventsList(calendarId: string | undefined) {
  return useQuery<CalendarEventSummary[]>({
    queryKey: queryKeys.calendars.events(calendarId ?? ''),
    queryFn: () => listCalendarEvents(calendarId!),
    enabled: !!calendarId,
    staleTime: 1000 * 30,
  })
}
